
import React from "react";
import PredictionCard from "@/components/prediction/PredictionCard";
import HiddenPredictionCard from "@/components/prediction/HiddenPredictionCard";
import { type SubscriptionPlan } from "@/utils/predictionUtils";

export type GameType = "milhar" | "centena" | "grupo" | "duque" | "terno";

interface PredictionGridProps {
  gameType: GameType;
  predictions: string[];
  userPlan: SubscriptionPlan;
  isFederalLottery: boolean;
}

const PredictionGrid: React.FC<PredictionGridProps> = ({ 
  gameType, 
  predictions, 
  userPlan, 
  isFederalLottery 
}) => {
  // Para usuários gratuitos, mostrar apenas 2 palpites + 8 bloqueados
  if (userPlan === "free" && (gameType === "milhar" || gameType === "centena")) {
    const visiblePreds = predictions.slice(0, 2);
    const hiddenCount = 8;
    
    return (
      <div className={`grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 justify-items-center max-w-4xl mx-auto mb-6 ${isFederalLottery ? 'p-4 border-2 border-gold-500 rounded-lg bg-gradient-to-br from-gold-50/20 to-yellow-50/20' : ''}`}>
        {/* Palpites visíveis */}
        {visiblePreds.map((prediction, index) => (
          <PredictionCard
            key={`${gameType}-visible-${index}`}
            prediction={prediction}
            type={gameType}
            showAnimal={false}
          />
        ))}
        
        {/* Palpites ocultos com símbolo VIP */}
        {Array.from({ length: hiddenCount }, (_, index) => (
          <HiddenPredictionCard
            key={`${gameType}-hidden-${index}`}
            index={index + visiblePreds.length + 1}
          />
        ))}
      </div>
    );
  }

  // Para usuários gratuitos tentando acessar modalidades premium
  if (userPlan === "free" && (gameType === "grupo" || gameType === "duque" || gameType === "terno")) {
    return (
      <div className={`grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 justify-items-center max-w-4xl mx-auto mb-6 ${isFederalLottery ? 'p-4 border-2 border-gold-500 rounded-lg bg-gradient-to-br from-gold-50/20 to-yellow-50/20' : ''}`}>
        {Array.from({ length: 10 }, (_, index) => (
          <HiddenPredictionCard
            key={`${gameType}-premium-${index}`}
            index={index + 1}
          />
        ))}
      </div>
    );
  }

  // Para usuários com planos pagos, mostrar todos os palpites
  return (
    <div className={`grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 justify-items-center max-w-4xl mx-auto mb-6 ${isFederalLottery ? 'p-4 border-2 border-gold-500 rounded-lg bg-gradient-to-br from-gold-50/20 to-yellow-50/20' : ''}`}>
      {predictions.map((prediction, index) => (
        <PredictionCard
          key={`${gameType}-${index}`}
          prediction={prediction}
          type={gameType}
          showAnimal={gameType === "grupo"}
        />
      ))}
    </div>
  );
};

export default PredictionGrid;
